import React, { useState, useEffect } from 'react';
import {
  Text,
  styled,
  Container,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { BackgroundImage } from './AcordionHorizontal';
import { InfoCuota } from '..';
import { keyframes, css } from 'styled-components';
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size';
import { RedirectCTAs } from '..';
import { Offer } from 'src/types';

interface LiProps {
  idLi: number;
  shadowSide?: string;
  isVertical?: boolean;
  colorTheme?: string;
  numberOfOffers: number;
}

//para el correcto funcionamiento del acordion según el númeo de ofertas que se muestren se debe ajustar el flex
//del que está active y, por temas de un correcto funcionamiento de la animación el min-width de la section-offer


const LiWrapper = styled.li<LiProps>`
  flex: 1;
  display: flex;
  position: relative;
  align-items: stretch;
  box-shadow: ${(props) =>
    props.colorTheme === 'inverted' && props.shadowSide === 'interior' ? 'inset -10px 0px 9px -5px rgba(0,0,0,0.5)' :
      props.colorTheme === 'inverted' ? '10px 0px 20px 0px rgba(0,0,0,0.7)' :
        props.shadowSide === 'interior' ? 'inset -10px 0px 9px -5px rgba(0,0,0,0.1)' : '10px 0px 20px 0px rgba(0, 0, 0, 0.4)'};
  padding: 0 5px;
  overflow: hidden;
  flex-direction: column;
  @media all and (min-width: 1600px){
    padding: 0 20px;
  }
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease-in;
  background:${(props) => props.colorTheme === 'inverted' ? '#001E50' : '#FFFFFF' };
  &.active {
    background: ${(props) => props.colorTheme === 'inverted' ? 'radial-gradient(circle at right center, rgb(0, 67, 122) 0%, rgb(0, 30, 80) 100%)' : '#FFFFFF' };
    flex: ${(props) => props.numberOfOffers === 3 ? 4 : props.numberOfOffers === 4 ? 5 : props.numberOfOffers === 2 ? 3 : 6};
    cursor: default;
    overflow: hidden;
    padding: 0;
    .section-offer {
      opacity: 1;
      min-width: ${(props) => props.numberOfOffers === 3 ? 'var(--size-grid012)' : 'var(--size-grid012)'};
    }
  }
  .section-title {
    height: fit-content;
    position:absolute;
    margin-top: 130px;
    margin-left: 24px;
    transform: rotate(-90deg) translateX(-100%);
    transform-origin: top left;
    white-space: nowrap;
  }
  .section-offer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    opacity: 0;
    position: absolute;
    padding-top: 100px;
    padding-bottom: 36px;
    width: 100%;
    height: ${(props)=> props.isVertical ? '50vh':'100vh'};
    min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
    @media all and (min-width: 1280px){
      padding-top: 140px;
      min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
    }
    @media all and (min-width: 1600px){
      padding-top: 186px;
      min-height: ${(props)=> props.isVertical ? '50vh': '100vh'};;
    }
    @media all and (min-width: 1920px){
      padding-top: 260px;
    }
    @media all and (min-width: 2560px){
      padding-top: 340px;
    }
  }
`;

const CarContent = styled.div`  
  display:flex;
  gap: 36px;
  padding: 0 36px;
`;

const fadeInImage = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

interface CarImageProps {
  small?: boolean;
  taigo?: boolean;
  height?: number;
  isVertical: boolean;
}

const ImageWrapper = styled.div<CarImageProps>`
  align-self: flex-start;
  position: relative;
  width: 100%;
  height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  min-height:${(props)=> props.isVertical ? '50vh':'100vh'};
  display: ${(props) => props.height < 560 && props.small ? 'flex' : null};
  align-items: ${(props) => props.height < 560 && props.small ? 'flex-end' : null};
  @media all and (min-width: 1280px) {
    display: ${(props) => props.height < 720 && props.small ? 'flex' : null};
    align-items: ${(props) => props.height < 720 && props.small ? 'flex-end' : null};
    min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  }
  @media all and (min-width: 1600px) {
    display: ${(props) => props.height < 1000 && props.small ? 'flex' : null};
    align-items: ${(props) => props.height < 1000 && props.small ? 'flex-end' : null};
    min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  }
`;

const CarImage = styled.img<CarImageProps>`
  position: ${(props) => props.small ? 'absolute' : null};
  animation: ${(props) => props.small? null : css`${fadeInImage} 0.2s ease-in`};
  width: ${(props) => props.small ? 'var(--size-grid006)' : 'var(--size-grid009)'};
  height: auto;
  transform:${(props) => props.taigo && props.small ? 'translateX(-20%) scale(1.2)' : props.taigo ? 'scale(1.2)' : 'translateX(5%)'};
  bottom: ${(props) => props.isVertical && props.small ? '25%' : props.small ? '18%' :  null};
  right: ${(props) => props.small ? null : props.taigo ? '-64px' : '-126px'};
  margin-bottom: ${(props) => props.small ? null : '32px'};
  transform-origin: center bottom;
  @media all and (min-width: 1600px) {
    width: ${(props) => props.small ? 'var(--size-grid006)' : 'var(--size-grid009)' };
  }
  @media all and (min-width: 1920px) {
    margin-bottom: ${(props) => props.small ? null : '64px'};
    width: ${(props) => props.small ? '480px' : '720px' };
    transform:${(props) => props.taigo && props.small ? 'translateX(-20%) ' : 'translateX(5%)'};
  }
`;

interface LiSectionProps {
  active: number;
  handleClick: (e: React.MouseEvent, i: number) => void;
  id: number;
  offer: Offer;
  numberOfOffers: number;
  backgroundImageUrl?: string;
  theme?: string;
}

export const LiSection = (props: LiSectionProps) => {
  const { handleClick, active, id, offer, numberOfOffers, backgroundImageUrl, theme } = props;
  const height = useWindowHeight();
  const width = useWindowWidth();
  const motorizacionArray = offer.motorizacion.split(' ');

  const [isVertical, setVertical] = useState<boolean>(false);

  useEffect(()=>{
    if(width - height <= 100 ||  height > width) {
      setVertical(true);
    } else {
      setVertical(false);
    }
  },[width]);

  return (
    <LiWrapper onClick={(e) => handleClick(e, id)} colorTheme={theme} className={id === active ? 'active' : 'inactive'} idLi={id} shadowSide={id < active ? 'interior' : 'exterior'} isVertical={isVertical} numberOfOffers={numberOfOffers}>
      {
        id !== active ? (
          <>        
            <div className="section-title">
              <Text appearance={TokenTextAppearance.headline300} bold>{offer.carlineTitle} {motorizacionArray[0]}</Text>
            </div>
            <ImageWrapper height={height} small taigo={offer.carlineTitle === 'Taigo' ? true : false} isVertical={isVertical}>
              <CarImage src={offer.mediaAssets.D6MOFASideview} height={height} isVertical={isVertical} small taigo={offer.carlineTitle === 'Taigo' ? true : false} />
            </ImageWrapper>           
          </>

        ) : (
          <>
            {
              backgroundImageUrl && <BackgroundImage src={backgroundImageUrl} liSection idLi={id} isVertical={isVertical}/>
            }
            <div className='section-offer'>
              <CarContent className='car-content'>
                <InfoCuota offer={offer} />
                <Container>
                  <CarImage src={offer.mediaAssets.D6MOFASideview} isVertical={isVertical} taigo={offer.carlineTitle === 'Taigo' ? true : false} />             
                </Container>
              </CarContent>
              <RedirectCTAs offer={offer} />
            </div>
          </>
        )
      }
    </LiWrapper>
  );
};
